<template>
  <a class="item ripple" href="#" @click.prevent="$emit('click')">
    <div>
      <div class="titulo">{{ titulo }}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    icono: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    subtitulo: {
      type: String,
      required: false,
      default: null
    },
    clase: {
      type: String,
      required: false,
      default: "poliza"
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: $naranjaMMT;
  border: 7px solid $naranjaMMT;
  margin-bottom: 0.9rem;
}

.titulo {
  color: #ddd;
  font-weight: 500;
}

.img-bg {
  margin-left: 30px;
  margin-right: 10px;
  width: 1rem;
  border-radius: 50%;
}

.sini {
  background-color: $naranjaMMT;
  border: 1px solid $naranjaMMT !important;
}

a {
  text-decoration: none;
}
</style>
